<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
import { defineComponent } from 'vue'
import { Logger } from 'aws-amplify';
import { useDoorValues } from '@/const/useDoorValues'

const logger = new Logger('App');

export default defineComponent({
  setup() {
    logger.info('App')
    const { appTitle } = useDoorValues()
    document.title = appTitle
    return {}
  }
})
</script>
